const login = {
    redirecting: 'Redirecting to Login',
    redirectingDesc:
      'No login status detected, redirecting you to the unified authentication center...',
    failed: 'Unable to connect to sign-in',
    failedDesc: 'The sign-in service did not respond. Check your network or proxy connection, then retry.',
    retry: 'Retry sign-in',
  }

export default login
